var _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMoreSecondary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_more_secondary",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_more",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 16,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_more-2",
    "data-name": "ic_more",
    transform: "translate(-192 580) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2,0A2,2,0,1,0,4,2,2.006,2.006,0,0,0,2,0Z",
    transform: "translate(559 198)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M2,0A2,2,0,1,0,4,2,2.006,2.006,0,0,0,2,0Z",
    transform: "translate(573 198)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M2,0A2,2,0,1,0,4,2,2.006,2.006,0,0,0,2,0Z",
    transform: "translate(566 198)",
    fill: "#909090"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Box-2",
    "data-name": "Box",
    width: 24,
    height: 32,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMoreSecondary);
export default __webpack_public_path__ + "static/media/ic_more_secondary.89691b8ab4c626ef42319697abb126cf.svg";
export { ForwardRef as ReactComponent };